export const inventoryType = {
  physical: "PHYSICAL",
  digital: "DIGITAL",
  progressive: "PROGRESSIVE",
}